import React from "react";
import avatar from "../../assets/images/avatar.png";
import superAdminSale_Image from "../../assets/images/superAdminSale_Image.png";
import attachment_pin_02 from "../../assets/icons/attachment_pin_02.png";
import like_Icon from "../../assets/icons/like_Icon.png";
import cross_icon from "../../assets/icons/cross_icon.png";

const SocialMediaPostModal = ({ setSocialMediaPost }) => {
  return (
    <>
      <div className="modal-wrapper"></div>
      <div className="modal-container px-4 rounded-lg w-[30%]">
        <img src={superAdminSale_Image} alt="sale image" />
        <img
          src={cross_icon}
          alt="cross"
          className="absolute top-8 right-3 cursor-pointer"
          onClick={() => setSocialMediaPost(false)}
        />
        <div className="flex flex-col py-4">
          <div className="flex">
            <div className="text-[32px] font-bold">Social Media Posts</div>
          </div>
          <div className="flex mt-3">
            <div className="text-[24px]">Description</div>
          </div>

          <div className="mt-2">
            <p className="text-[16px]">
              Generate engagement by asking a multiple-choice question about
              your audience's preferences.
            </p>
          </div>

          <div className="flex mt-3">
            <div className="text-[24px]">Comments</div>
          </div>

          <div className="flex mt-4 w-[95%]">
            <div>
              <img
                src={avatar}
                alt="profile"
                className="w-6 rounded-full object-contain mr-2"
              />
            </div>
            <div className=" border rounded-lg border-[#95C2FF] w-full">
              <input
                type="text"
                placeholder="Reply or post an update"
                className="ml-2 w-[95%] text-[14px]"
              />
              <div className="flex mb-4 mt-8 justify-between w-[95%]">
                <img
                  src={attachment_pin_02}
                  alt="attachment"
                  className="w-5 object-contain rounded-full ml-2"
                />
                <button className="bg-[#2F80ED] text-white p-1 rounded-lg px-4 text-[12px]">
                  Send
                </button>
              </div>
            </div>
          </div>

          <div className="flex my-4 w-[95%]">
            <div>
              <img
                src={avatar}
                alt="profile"
                className="w-6 rounded-full object-contain mr-2"
              />
            </div>
            <div className="w-full ml-2">
              <p className="font-bold mt-2 text-[13px]">Brooklyn</p>
              <p className="text-[13px] text-[#4F4F4F] mt-2">
                we are 1 week away from launch! Thank you for every team member
                for their hard work. we are 1 week away from launch! Thank you
                for every team member for their hard work.
              </p>
              <div className="flex mt-2 items-center">
                <p className="text-[10px]">2 hours ago</p>
                <p className="text-[10px] ml-2 mr-1 text-[#2F80ED]">5</p>
                <img
                  src={like_Icon}
                  alt="like"
                  className="w-3 object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SocialMediaPostModal;
